import Header from '../components/Elements/header';
import Footer from '../components/Elements/footer';
import { Route, Routes } from 'react-router-dom';
import HomeViews from '../views/home';

function HomeLayout() {
  return (
    <>
      <Header />
        <div className='pt-10'>
          <Routes>
            <Route path="/*" element={<HomeViews />} />
          </Routes>
        </div>
      <Footer />
    </>
  );
}

export default HomeLayout;
